module.exports = __webpack_public_path__ + "static/media/hdsd-report-guide-mobile.866e10d4.jpg";